import { EMISSIONS_API_URL } from "./apiConfig";

export function readEmissionsCache() {
  try {
    const cached = JSON.parse(localStorage.getItem("emissionsCache"));
    if (cached?.apiUrl === EMISSIONS_API_URL && Array.isArray(cached.rows)) {
      return cached;
    }
    // Legacy entries have no reliable API origin and must be fetched again.
    localStorage.removeItem("emissionsCache");
  } catch {
    return null;
  }
  return null;
}

export function writeEmissionsCache(data) {
  localStorage.setItem(
    "emissionsCache",
    JSON.stringify({ ...data, apiUrl: EMISSIONS_API_URL })
  );
}
